import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiEndpoints } from '../constants/api-endpoints';
import { IUserSelectCai } from '../interfaces/user-select-cai';
import { HttpUtilityService } from './http.utility.service';

@Injectable({
  providedIn: 'root',
})
export class UserSelectCaiService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  getAllList(filters: any): Observable<HttpResponse<IUserSelectCai[]>> {
    const url = `${apiEndpoints.userSelectLoadEmail}${filters.cond || ''}`;
    return this.httpUtilityService.get<any[]>(url);
  }
}
